import { DocumentFormProps } from '@/Domains/Document/UI/DocumentForm/DocumentForm';
import { useContact, useProperty, useUser } from '@/OneLiners';

import {
	FaBuilding,
	FaCalendarAlt,
	FaUser,
	Form,
	Formik,
	FormikProps,
	InputField,
	OptionHelper,
	RequiredNote,
	SelectField,
	SubmitButton,
	useAppEnum
} from '@/Shared';

import React, { FC } from 'react';
import { RentalCommitmentFormValidationSchema } from '../../Logic/ContactFormValidation';

const RentalCommitmentForm: FC<DocumentFormProps> = ({
	document,
	handleClose,
	handleCancel,
	id
}) => {

	const contactHook = useContact();
	const userHook = useUser();
	const propertyHook = useProperty();

	const contactOptions = OptionHelper.contactOptions(contactHook.dataMap.toArray());
	const referrerOptions = OptionHelper.userOptions(userHook.dataMap.toArray());

	const { PropertyEnums } = useAppEnum();
	const propertyOptions = OptionHelper.propertyOptions(
		propertyHook.dataMap.toArray(),
		PropertyEnums.PropertyTypeEnum
	);

	const initialValues = {
		id: id,
		propertyId: null,
		agentId: null,
		bookingDate: null,
		leaseSigningDate: null,
		moveInInspectionDate: null
	};

	const handleSubmit = (values: Record<string, any>) => {
		handleClose();
		document.handler(values);
	}


	return (
		<div className="fade-in" data-testid="GenericDomainForm">
			{/* Formik wrapper for handling form state and validation */}
			<Formik<any>
				initialValues={initialValues}
				enableReinitialize={true}
				validationSchema={RentalCommitmentFormValidationSchema}
				onSubmit={handleSubmit}
			>

				{(formikProps: FormikProps<any>) =>
					<Form className='form-in-modal'>
						<div className='sm-scroll'>
							<fieldset>
								<legend>Informations générales</legend>
								<SelectField
									label='Preneur'
									icon={<FaUser />}
									name='id'
									placeholder='Choisir un contact'
									options={contactOptions}
									required
								/>

								<SelectField
									label='Logement'
									icon={<FaBuilding />}
									name='propertyId'
									placeholder='Choisir un logement'
									options={propertyOptions}
									required
								/>
								<SelectField
									label='Conseiller'
									icon={<FaUser />}
									name='agentId'
									options={referrerOptions}
									placeholder="Choisir un conseiller"
									required
								/>
								<RequiredNote />
							</fieldset>
							<fieldset>
								<legend>Dates clés</legend>
								<InputField
									label='Date réseravation'
									icon={<FaCalendarAlt />}
									name='bookingDate'
									type='date' />
								<InputField
									label='Date signature bail'
									icon={<FaCalendarAlt />}
									name='leaseSigningDate'
									type='datetime-local'
								/>

								<InputField
									label='Date état des lieux'
									icon={<FaCalendarAlt />}
									name='moveInInspectionDate'
									type='datetime-local' />
							</fieldset>

						</div>
						{/* Submit button reflecting form validity and loading state */}
						<SubmitButton
							disabled={!formikProps.dirty || !formikProps.isValid}
							label='Générer'
						/>
					</Form>
				}
			</Formik >
		</div>
	);
}

export default RentalCommitmentForm;